export interface SubjectBadgeStyle {
  bg: string;
  text: string;
  border: string;
  pillStyle: string;
}

export function getLectureSubjectTheme(subjectName: string): {
  badgeBg: string;
  badgeText: string;
  badgeBorder: string;
  pill: string;
} {
  const norm = subjectName.toLowerCase();

  if (norm.includes('math')) {
    return {
      badgeBg: 'bg-sky-500/15 dark:bg-sky-500/20',
      badgeText: 'text-sky-700 dark:text-sky-300',
      badgeBorder: 'border-sky-500/30',
      pill: 'bg-sky-500/15 dark:bg-sky-500/20 text-sky-700 dark:text-sky-300 border-sky-500/30',
    };
  }

  if (norm.includes('evs') || norm.includes('sci') || norm.includes('plant') || norm.includes('earth')) {
    return {
      badgeBg: 'bg-emerald-500/15 dark:bg-emerald-500/20',
      badgeText: 'text-emerald-700 dark:text-emerald-300',
      badgeBorder: 'border-emerald-500/30',
      pill: 'bg-emerald-500/15 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-300 border-emerald-500/30',
    };
  }

  if (norm.includes('eng') || norm.includes('rhyme') || norm.includes('read')) {
    return {
      badgeBg: 'bg-pink-500/15 dark:bg-pink-500/20',
      badgeText: 'text-pink-700 dark:text-pink-300',
      badgeBorder: 'border-pink-500/30',
      pill: 'bg-pink-500/15 dark:bg-pink-500/20 text-pink-700 dark:text-pink-300 border-pink-500/30',
    };
  }

  if (norm.includes('telugu') || norm.includes('hindi') || norm.includes('वर्णमाला') || norm.includes('lang')) {
    return {
      badgeBg: 'bg-amber-500/15 dark:bg-amber-500/20',
      badgeText: 'text-amber-700 dark:text-amber-300',
      badgeBorder: 'border-amber-500/30',
      pill: 'bg-amber-500/15 dark:bg-amber-500/20 text-amber-700 dark:text-amber-300 border-amber-500/30',
    };
  }

  if (norm.includes('art') || norm.includes('craft') || norm.includes('draw')) {
    return {
      badgeBg: 'bg-yellow-500/15 dark:bg-yellow-500/20',
      badgeText: 'text-yellow-700 dark:text-yellow-300',
      badgeBorder: 'border-yellow-500/30',
      pill: 'bg-yellow-500/15 dark:bg-yellow-500/20 text-yellow-700 dark:text-yellow-300 border-yellow-500/30',
    };
  }

  if (norm.includes('life') || norm.includes('skill') || norm.includes('habit')) {
    return {
      badgeBg: 'bg-purple-500/15 dark:bg-purple-500/20',
      badgeText: 'text-purple-700 dark:text-purple-300',
      badgeBorder: 'border-purple-500/30',
      pill: 'bg-purple-500/15 dark:bg-purple-500/20 text-purple-700 dark:text-purple-300 border-purple-500/30',
    };
  }

  if (norm.includes('comp') || norm.includes('it') || norm.includes('tech')) {
    return {
      badgeBg: 'bg-cyan-500/15 dark:bg-cyan-500/20',
      badgeText: 'text-cyan-700 dark:text-cyan-300',
      badgeBorder: 'border-cyan-500/30',
      pill: 'bg-cyan-500/15 dark:bg-cyan-500/20 text-cyan-700 dark:text-cyan-300 border-cyan-500/30',
    };
  }

  if (norm.includes('phys') || norm.includes('pe') || norm.includes('exercise') || norm.includes('sport')) {
    return {
      badgeBg: 'bg-teal-500/15 dark:bg-teal-500/20',
      badgeText: 'text-teal-700 dark:text-teal-300',
      badgeBorder: 'border-teal-500/30',
      pill: 'bg-teal-500/15 dark:bg-teal-500/20 text-teal-700 dark:text-teal-300 border-teal-500/30',
    };
  }

  // Default: Indigo
  return {
    badgeBg: 'bg-indigo-500/15 dark:bg-indigo-500/20',
    badgeText: 'text-indigo-700 dark:text-indigo-300',
    badgeBorder: 'border-indigo-500/30',
    pill: 'bg-indigo-500/15 dark:bg-indigo-500/20 text-indigo-700 dark:text-indigo-300 border-indigo-500/30',
  };
}

/**
 * Which illustration a lesson wears, picked from its subject.
 *
 * The thumbnail already matches on the *title*, which works for "Numbers 1 to
 * 100" and not at all for "Revision — chapter 4". The subject is the thing a
 * school always fills in, so it decides the picture and the title only refines
 * it. Returns undefined for a subject with no illustration of its own, which
 * the thumbnail draws as its default.
 */
export function subjectTheme(subjectName: string): string | undefined {
  const name = subjectName.toLowerCase();

  if (name.includes('math')) return 'maths';
  if (name.includes('evs') || name.includes('sci')) return 'evs';
  if (name.includes('telugu')) return 'telugu';
  if (name.includes('art') || name.includes('craft') || name.includes('draw')) return 'art';
  if (name.includes('comp') || name.includes('tech')) return 'computer';
  if (name.includes('phys') || name.includes('sport')) return 'pe';
  if (name.includes('eng')) return 'english';

  return undefined;
}
